import { i18n } from '@/plugins/i18n';
import { useTrackStore } from '@/stores/track';

export function riskAssessmentToken(name: string, severity: string): string {
  const label = severity === 'risk_none' ? 'none' : severity;
  const patient = useTrackStore().classifications.find((item: any) => item.name === 'patient')?.value;
  if (patient) {
    const scopedToken = `assessment.${name}.${patient}.${label}.title`;
    const locales = [i18n.locale, ...[].concat(i18n.fallbackLocale || [])];
    if (locales.some(locale => typeof locale === 'string' && i18n.te(scopedToken, locale))) {
      return scopedToken;
    }
  }
  return `assessment.${name}.${label}.title`;
}
